<div class="landing">

    <!-- HERO -->
    <section class="hero">

        <div class="hero-glow hero-glow-left"></div>
        <div class="hero-glow hero-glow-right"></div>

        <div class="hero-content">

            <!-- <div class="brand-mark">
                <span class="brand-mark-line"></span>
                <span>MARKANT Bridge</span>
            </div> -->

            <div class="hero-badge">
                <i class="pi pi-bolt"></i>
                DATA TRANSFORMATION PLATFORM
            </div>

            <h1>
                MARKANT Bridge

            </h1>

            <p class="hero-subtitle">
                Salsify to Markant data transformation manager
            </p>

            <p class="hero-description">
                Create, edit and manage transformation rule sets,
                versions and output rules from one centralized workspace.
            </p>

            <div class="hero-actions">

                <button
                    type="button"
                    class="primary-button"
                    (click)="login()"
                >
                    Sign in
                    <i class="pi pi-arrow-right"></i>
                </button>

            </div>

        </div>


        <!-- TRANSFORMATION FLOW -->
        <div class="transformation-flow">

            <div class="flow-node">

                <div class="flow-icon">
                    <i class="pi pi-file"></i>
                </div>

                <div>
                    <span class="flow-label">
                        INPUT
                    </span>

                    <strong>
                        Salsify data
                    </strong>
                </div>

            </div>


            <div class="flow-line">
                <span></span>
                <i class="pi pi-angle-right"></i>
            </div>


            <div class="flow-node active">

                <div class="flow-icon">
                    <i class="pi pi-sliders-h"></i>
                </div>

                <div>
                    <span class="flow-label">
                        TRANSFORM
                    </span>

                    <strong>
                        Bridge rules
                    </strong>
                </div>

            </div>


            <div class="flow-line">
                <span></span>
                <i class="pi pi-angle-right"></i>
            </div>


            <div class="flow-node">

                <div class="flow-icon">
                    <i class="pi pi-send"></i>
                </div>

                <div>
                    <span class="flow-label">
                        OUTPUT
                    </span>

                    <strong>
                        Markant data
                    </strong>
                </div>

            </div>

        </div>

    </section>


    <!-- FEATURES -->
    <section class="features">

        <div class="section-heading">

            <div>
                <span class="section-eyebrow">
                    WORKSPACE
                </span>

                <h2>
                    Everything you need to manage transformations.
                </h2>
            </div>

            <p>
                Keep transformation logic structured, versioned
                and easy to maintain.
            </p>

        </div>


        <div class="feature-grid">

            <article class="feature-card">

                <div class="feature-number">
                    01
                </div>

                <div class="feature-icon">
                    <i class="pi pi-sitemap"></i>
                </div>

                <h3>
                    Rule Sets
                </h3>

                <p>
                    Organize business transformation logic
                    into manageable rule sets for each market.
                </p>

                <div class="feature-link">
                    Manage rules
                    <i class="pi pi-arrow-right"></i>
                </div>

            </article>


            <article class="feature-card">

                <div class="feature-number">
                    02
                </div>

                <div class="feature-icon">
                    <i class="pi pi-history"></i>
                </div>

                <h3>
                    Versioning
                </h3>

                <p>
                    Work with different rule versions while
                    keeping every change controlled and traceable.
                </p>

                <div class="feature-link">
                    Manage versions
                    <i class="pi pi-arrow-right"></i>
                </div>

            </article>


            <article class="feature-card">

                <div class="feature-number">
                    03
                </div>

                <div class="feature-icon">
                    <i class="pi pi-code"></i>
                </div>

                <h3>
                    Output Rules
                </h3>

                <p>
                    Define how every output cell is generated
                    from your source data and transformation rules.
                </p>

                <div class="feature-link">
                    Define outputs
                    <i class="pi pi-arrow-right"></i>
                </div>

            </article>

        </div>

    </section>


    <!-- FOOTER -->
    <footer class="landing-footer">

        <div>
            <strong>
                MARKANT Bridge
            </strong>

            <span>
                Data transformation manager
            </span>
        </div>

        <span>
            © 2026 MARKANT Bridge
        </span>

    </footer>

</div>